import { render, staticRenderFns } from "./ActionsGroups.vue?vue&type=template&id=c2b087ec&scoped=true&"
import script from "./ActionsGroups.vue?vue&type=script&lang=ts&"
export * from "./ActionsGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b087ec",
  null
  
)

export default component.exports